import { Breakpoints } from '@angular/cdk/layout';

/**
 * The screens on which the sidebar is an overlay (hidden until the menu button
 * opens it, hidden again after a page is picked) instead of a docked column.
 *
 * The layout and the navbar both ask this question and must never answer it
 * differently. The navbar used to ask "(max-width: 770px) or Tablet", and
 * Tablet covers 960-1279px landscape - an ordinary desktop window. There the
 * layout docked the sidebar while the navbar treated every menu click as a
 * phone tap and closed it, and the menu button, which only toggles the icon
 * rail on desktop, could not bring it back until a reload.
 */
export const NAV_OVERLAY_QUERIES: string[] = ['(max-width: 500px)', Breakpoints.Handset];
